import { addLocale, setDefaultLang, useLocale } from 'ttag';
import { DEFAULT_LOCALE } from './LocaleResolver';
export const LOCALES_BASE_PATH = '/locales';
const LOCALE_FETCH_TIMEOUT_MS = 5000;
export class LocaleService {
    constructor(options = {}) {
        var _a, _b;
        this.currentLocale = DEFAULT_LOCALE;
        this.loadedLocales = new Set();
        this.onLocaleChanged = options.onLocaleChanged;
        this.loadJson = (_a = options.loadJson) !== null && _a !== void 0 ? _a : this.fetchJsonWithHttp.bind(this);
        this.localesBasePath = (_b = options.localesBasePath) !== null && _b !== void 0 ? _b : LOCALES_BASE_PATH;
        setDefaultLang(DEFAULT_LOCALE);
    }
    localeResourcePath(relativePath) {
        const base = this.localesBasePath.replace(/\/$/, '');
        return `${base}/${relativePath}`;
    }
    getCurrentLocale() {
        return this.currentLocale;
    }
    getAvailableLocales() {
        if (!this.catalog) {
            this.catalog = this.loadJson(this.localeResourcePath('config/locales.json'));
            this.catalog.catch(() => {
                this.catalog = undefined;
            });
        }
        return this.catalog;
    }
    /** Loads locale JSON if needed and activates it. Throws when the pack cannot be loaded. */
    async loadAndActivateLocale(locale) {
        if (locale !== DEFAULT_LOCALE && !this.loadedLocales.has(locale)) {
            const data = await this.loadJson(this.localeResourcePath(`${locale}.json`));
            addLocale(locale, data);
            this.loadedLocales.add(locale);
        }
        this.activateLocale(locale);
    }
    activateLocale(locale) {
        var _a;
        useLocale(locale);
        this.currentLocale = locale;
        (_a = this.onLocaleChanged) === null || _a === void 0 ? void 0 : _a.call(this, locale);
    }
    async fetchJsonWithHttp(url) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), LOCALE_FETCH_TIMEOUT_MS);
        try {
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) {
                throw new Error(`Failed to fetch ${url}: ${response.status}`);
            }
            return (await response.json());
        }
        finally {
            clearTimeout(timeout);
        }
    }
}
